export default __webpack_public_path__ + "static/media/syster.fb844201.webp";